import { highlightText } from '~/shared/lib/highlight-text'
import { Text } from '~/shared/ui'

interface EventNotesProps {
  notes: string
  searchQuery: string
}

/** Comments/notes section displayed below event content. */
export function EventNotes({ notes, searchQuery }: EventNotesProps) {
  return (
    <div className="mt-1 py-1">
      <div className="flex flex-col">
        <Text
          className="text-alert-error-content"
          appearance="OVERLINE"
        >
          Comments
        </Text>
        <Text appearance="BODY2">{highlightText(notes || '', searchQuery)}</Text>
      </div>
    </div>
  )
}
